<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { patchLogin } from '../../api/EnzianApi';
	import DefaultButton from '../../basic/buttons/DefaultButton.svelte';
	import DefaultPasswordInput from '../../basic/input/DefaultPasswordInput.svelte';
	import InputLabel from '../../basic/input/InputLabel.svelte';
	import Modal from '../../basic/modal/Modal.svelte';
	import ModalHeader from '../../basic/modal/ModalHeader.svelte';
	import { validatePassword } from '../../helper/Validation.js';
	import { addNotification } from '../../notification/Notificationstore';

	interface Props {
		loginId: number;
		onModalClose: () => void;
	}

	let { loginId, onModalClose }: Props = $props();
	//Password values
	let firstPassword: string | null = $state(null);
	let secondPassword: string | null = $state(null);

	let passwordMatch = $derived(
		firstPassword === secondPassword &&
			firstPassword != null &&
			firstPassword != '' &&
			validatePassword(firstPassword)
	);

	async function handlePasswordChange() {
		if (loginId === null || !passwordMatch) return;

		try {
			await patchLogin(loginId, {
				password: firstPassword
			});
			onModalClose();
		} catch (error: any) {
			addNotification({
				message: $_('adminview.change_password.error_password_change'),
				type: 'error',
				error: error
			});
		}
	}
</script>

<Modal {onModalClose}>
	{#snippet header()}
		<div>
			<ModalHeader text={$_('adminview.change_password.header')} />
		</div>
	{/snippet}
	{#snippet content()}
		<div class="p-8">
			<div class="flex flex-col">
				<div>
					<div class="mb-4">
						<InputLabel
							label={$_('general.lbl_password')}
							labelAddon={$_('general.lbl_password_addon')}
						/>
						<DefaultPasswordInput
							propertyName="password"
							bind:value={firstPassword}
							placeholder={$_('general.lbl_password')}
						/>
					</div>

					<InputLabel
						label={$_('adminview.change_password.lbl_password_rewrite')}
						labelAddon={$_('general.lbl_password_addon')}
					/>
					<DefaultPasswordInput
						propertyName="password1"
						bind:value={secondPassword}
						placeholder={$_('adminview.change_password.lbl_password_rewrite')}
					/>
				</div>
			</div>
		</div>
	{/snippet}

	<!-- Buttons-->

	{#snippet footer()}
		<div class="flex justify-end gap-4">
			<DefaultButton onClick={onModalClose} secondary={true} text={$_('general.lbl_cancel')} />
			<DefaultButton
				onClick={() => {
					handlePasswordChange();
				}}
				disabled={!passwordMatch}
				text={$_('adminview.change_password.bt_change')}
			/>
		</div>
	{/snippet}
</Modal>
